import { Box, Center, Flex, Heading, Image, Text } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { AiFillDislike } from 'react-icons/ai';
import UserContext from '../../context/userContext';
import './Favorites.css';
import Landscape from './landscape.jpg';

function Favorites() {
  const { userData } = useContext(UserContext);
  const user = userData.user;
  const [favorites, setFavorites] = useState([]);

  const removeFavorites = id => {
    let token = localStorage.getItem('auth-token');
    fetch(
      'https://mern-stack-movies-app.herokuapp.com/movies/removeFavorites',
      {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
        body: JSON.stringify({
          postId: id,
        }),
      }
    )
      .then(value => {
        const notify = () =>
          toast.success('Favorite removed', {
            duration: 4000,
            id: 'loading toast',
          });
        notify();
        console.log('Success code is', value);
      })
      .catch(err => {
        const notify = () =>
          toast.error('Could not remove favorite', {
            duration: 4000,
            id: 'loading toast',
          });
        notify();
        console.log('An error occurred', err);
      });
    const newFavorites = favorites.filter(favorite => favorite.id !== id);
    setFavorites(newFavorites);
  };

  return (
    <Box mb={10}>
      <Toaster />
      {userData.user ? (
        (axios
          .get('https://mern-stack-movies-app.herokuapp.com/movies/favorites', {
            headers: {
              'x-auth-token': localStorage.getItem('auth-token'),
            },
          })
          .then(
            response => {
              setFavorites(response.data);
            },
            error => {
              console.log('Error is', error);
            }
          ),
        (
          <Box>
            <Center>
              <Heading as="u">YOUR FAVORITES</Heading>
            </Center>
            <Flex direction="row" wrap="wrap" justify="center">
              {favorites ? (
                favorites.map((favorite, index) => {
                  return (
                    <Flex
                      key={index}
                      direction="column"
                      align="center"
                      justify="start"
                      textAlign="center"
                      w="300px"
                      border="2px solid #000"
                      mt={10}
                      mx={5}
                      bg="#e8ecf1"
                      overflow="hidden"
                    >
                      <Image
                        alt=""
                        src={
                          favorite.poster === undefined
                            ? `${Landscape}`
                            : `${favorite.poster}`
                        }
                        transition="transform 0.5s ease"
                        _hover={{
                          transform: 'translateY(80px) scale(2.0)',
                        }}
                        pb={5}
                      />
                      <Box pb={5} pl={5} pr={5}>
                        <Text
                          fontSize="lg"
                          fontWeight="700"
                          as="u"
                          color="#ff0000"
                        >
                          Title
                        </Text>
                        <Text fontSize="lg" color="#000" mt={2} mb={2}>
                          {favorite.title}
                        </Text>
                      </Box>
                      <Text
                        fontSize="lg"
                        fontWeight="700"
                        mb={3}
                        as="u"
                        color="#ff0000"
                      >
                        Remove from favorites
                      </Text>
                      {user && (
                        <AiFillDislike
                          onClick={() => {
                            removeFavorites(favorite._id);
                          }}
                          style={{
                            fontSize: 24,
                            marginBottom: 20,
                            color: '#ff0000',
                          }}
                        />
                      )}
                    </Flex>
                  );
                })
              ) : (
                <Box className="alert">
                  <Text fontWeight="700">No favorites found</Text>
                </Box>
              )}
            </Flex>
          </Box>
        ))
      ) : (
        <Center>
          <Text w="60%" style={{ marginTop: 30 }}>
            You are not logged in. You have to register and login to see your
            favorites.
          </Text>
        </Center>
      )}
    </Box>
  );
}

export default Favorites;
